require('./_wks-define')('asyncIterator');



//////////////////
// WEBPACK FOOTER
// ./node_modules/.2.5.7@core-js/library/modules/es7.symbol.async-iterator.js
// module id = 465
// module chunks = 1